
    var runtime = require('vue-svg-component-runtime')
    module.exports = {
      __esModule: true,
      default: runtime.svgComponent({
  "tag": "svg",
  "attrsMap": {
    "version": "1.1",
    "id": "图层_1",
    "xmlns": "http://www.w3.org/2000/svg",
    "xmlns:xlink": "http://www.w3.org/1999/xlink",
    "x": "0px",
    "y": "0px",
    "viewBox": "0 0 16 16",
    "style": "enable-background:new 0 0 16 16;",
    "xml:space": "preserve"
  },
  "children": [
    {
      "tag": "path",
      "attrsMap": {
        "id": "路径_8920",
        "class": "st0",
        "d": "M11.9,15H9.2c-0.3,0-0.5-0.2-0.5-0.5v-4.3H7.1v4.3c0,0.3-0.2,0.5-0.5,0.5H4\r\n\tc-0.8,0-1.5-0.7-1.5-1.5V9.1H2.2C1.5,9.1,1,8.6,1,7.9c0,0,0,0,0,0c0-0.3,0.1-0.6,0.3-0.8l5.1-5.4c0.8-0.9,2.2-0.9,3.1-0.1\r\n\tc0,0,0,0.1,0.1,0.1l5.1,5.4c0.5,0.5,0.4,1.2,0,1.7c-0.2,0.2-0.5,0.3-0.8,0.3h-0.4v4.4C13.4,14.3,12.7,15,11.9,15z M9.7,14h2.2\r\n\tc0.3,0,0.5-0.2,0.5-0.5V8.6c0-0.3,0.2-0.5,0.5-0.5h0.9C13.9,8.1,14,8,14,8c0-0.1,0-0.1,0-0.2L8.9,2.4C8.4,1.9,7.7,1.9,7.2,2.3\r\n\tc0,0,0,0,0,0c0,0,0,0,0,0L2,7.8C2,7.8,2,7.9,2,8c0,0,0.1,0,0.1,0H3c0.3,0,0.5,0.2,0.5,0.5v4.9C3.5,13.8,3.7,14,4,14h2.2v-3.8\r\n\tc0-0.6,0.4-1,1-1c0,0,0,0,0,0h1.6c0.6,0,1,0.4,1,1c0,0,0,0,0,0L9.7,14z"
      }
    }
  ]
})
    }
  